function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(n); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React, { useEffect, useState, Fragment, forwardRef, useRef } from 'react';
import cn from 'classnames';
import ResizeObserver from 'resize-observer-polyfill';
import { string, node, bool, number } from 'prop-types';
import { ScrollSyncPane } from 'react-scroll-sync';
/**
 * ScrollableContainer component.
 */

var ScrollableContainer = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var children = _ref.children,
      className = _ref.className,
      initialOffset = _ref.initialOffset,
      synced = _ref.synced,
      width = _ref.width,
      restProps = _objectWithoutProperties(_ref, ["children", "className", "initialOffset", "synced", "width"]);

  var mainContainerRef = ref || useRef();
  var transformContainerRef = useRef();
  var transform = initialOffset ? "translateX(".concat(initialOffset, "px)") : null;

  var _useState = useState({
    transform: transform
  }),
      _useState2 = _slicedToArray(_useState, 2),
      transformContainerStyle = _useState2[0],
      setTransformContainerStyle = _useState2[1];

  var _useState3 = useState({
    minWidth: width
  }),
      _useState4 = _slicedToArray(_useState3, 2),
      widthContainerStyle = _useState4[0],
      setWidthContainerStyle = _useState4[1];
  /**
   * Enable scrolling on a container that was initially offset.
   *
   * Once the client-side JS runs replace the SSR-friendly transform offsets
   * with a scrollable container set to the correct position. This means the
   * container should render scrolled to the correct position before the
   * scrolling behaviour kicks in.
   */


  useEffect(function () {
    if (transform) {
      setTransformContainerStyle(null);
      mainContainerRef.current.style.overflowX = 'auto';
      mainContainerRef.current.scrollLeft = initialOffset * -1;
    } // The ResizeObserver is used in part so that any CSS changes applied
    // after the initial render are respected.


    var observer = new ResizeObserver(function () {
      if (!width) {
        setWidthContainerStyle({
          minWidth: transformContainerRef.current.firstChild.scrollWidth
        });
      }
    });
    observer.observe(transformContainerRef.current.firstChild);
    return function () {
      observer.disconnect();
    };
  }, []);
  var Wrapper = synced ? ScrollSyncPane : Fragment;
  return /*#__PURE__*/React.createElement(Wrapper, null, /*#__PURE__*/React.createElement("div", _extends({
    className: cn('scrollable-container', className, initialOffset && 'scrollable-container--with-initial-offset'),
    ref: mainContainerRef
  }, restProps), /*#__PURE__*/React.createElement("div", {
    className: "scrollable-container__width-container",
    style: widthContainerStyle
  }, /*#__PURE__*/React.createElement("div", {
    style: transformContainerStyle,
    ref: transformContainerRef
  }, children))));
});
ScrollableContainer.defaultProps = {
  className: null,
  children: null,
  initialOffset: 0,
  synced: false,
  width: null
};
ScrollableContainer.propTypes = process.env.NODE_ENV !== "production" ? {
  /** Additional class names to add to the component root. */
  className: string,

  /** The contents of the container. */
  children: node,

  /** Any initial offset to render the container at when initially rendered. */
  initialOffset: number,

  /** True if the container should be synced with others using react-scroll-sync. */
  synced: bool,

  /** An explicit width for the container contents (must be set if `initialOffset` is set). */
  width: number
} : {};
export default ScrollableContainer;